import React, { useMemo } from 'react';

import { CircularProgress, SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StyledBackdrop, StyledWrapper } from './Spinner.styles';

export interface SpinnerProps {
    absolute?: boolean;
    backdrop?: boolean;
    size?: number;
    shadow?: 'default' | 'lower';
    sx?: SxProps;
}

export const Spinner = ({
    backdrop = false,
    absolute = false,
    size = 40,
    shadow = 'default',
    sx,
    ...props
}: SpinnerProps) => {
    const { t } = useTranslation();

    const spinner = useMemo(
        () => <CircularProgress size={size} sx={sx} aria-label={t('loading')} {...props} />,
        [t, size, sx, props],
    );

    return backdrop ? (
        <StyledBackdrop open={true} shadow={shadow} style={{ position: absolute ? 'absolute' : 'fixed' }}>
            {spinner}
        </StyledBackdrop>
    ) : (
        <StyledWrapper>{spinner}</StyledWrapper>
    );
};
